import React from 'react'
import PropTypes from "prop-types";

/**
 * Este componente renderiza la ultima sección del club MakeMake que corresponde a la información de contacto y recibe como props los textos de la interfaz.
 */

const NuestraComunidad = (props) => {

  const { traducciones } = props;

  return (
    <div className="pt-5">
    <div className="container">
        <div className="col-xl-8 col-lg-12 mx-auto">
          <div className="degradado-comunidad row mx-0 ">
          </div>
          <div className='d-md-flex align-items-center justify-content-center onbackground-third--bordered'>
            <div className='mx-2 my-2'>
            <img alt="niña-saltando" src="/img/club-makemake/nina-comunidad.png" className="img-fluid d-none d-md-block background-contraste"/>
            </div>
            <div className='titulo-planes2 titulo-morado-act text-center mx-lg-2 my-lg-3 ml-sm-2 my-sm-2'>
            {traducciones?.haz_parte.titulo || '¿Quieres ser parte de nuestra comunidad?'}
            </div>
            <div className='cuentanos-div mx-5 mx-md-0 py-lg-2 '>
            <p className='mx-lg-3 mx-sm-2 my-2 my-md-0 text-center text-md-left onbackground-third--color'>{traducciones?.haz_parte.contacto || 'Cuentanos sobre tu proyecto. Escribenos a '}<span className='correo-estilo'>contacto@makemake.com.co </span></p> 
            </div>
          </div>
        </div>
    </div>
</div>
  )
}

export default NuestraComunidad;

NuestraComunidad.propTypes={
    /**
     * Es un objeto que trae los textos de la interfaz, especificamente los de mi cuenta. Estos cambian dependiendo del idioma activo.
     */
    traducciones: PropTypes.object.isRequired
}
